import _merge from 'lodash/merge'
import taboola from './taboola'
import taboolaDefaults from './taboolaDefaults'

export default {
  'editionSettings': {
    'key': 'espnza-en',
    'site': 'espn',
    'language': 'en',
    'country': 'za',
    'domain': 'africa.espn.com',
    'editionSiteId': '27',
    'https': true
  },
  'navId': '18748270',
  'dictionarySection': 'espn',
  'javaLocale': {
    'language': 'en',
    'region': 'GB'
  },
  'dateTime': {
    'long': 'dddd MMMM d, yyyy',
    'medium': 'MMMM d, yyyy',
    'short': 'M/d',
    'timeFormat': 'h:mm',
    'firstDayOfWeek': 'Sunday',
    'timeZone': 'Etc/GMT',
    'defaultFormat': 'd MMM, yyyy',
    'timeZoneString': 'GMT',
    'timeZoneBucket': 'Europe/London',
    'MMM D, YYYY': 'D MMM, YYYY',
    'M/D/YYYY': 'D/M/YYYY',
    'MM/DD/YYYY': 'DD/MM/YYYY',
    'MMDDYYYY': 'DDMMYYYY',
    'MMMM Do YYYY': 'Do MMMM YYYY',
    'dddd, MMMM Do YYYY' : 'dddd, Do MMMM YYYY',
    'ddd, MMM D YYYY': 'ddd, D MMM YYYY',
    'M/D': 'D/M',
    'ddd, M/D': 'ddd, D/M',
    'MMMM D, YYYY': 'D MMMM YYYY',
    'dddd, M/D': 'dddd, D/M',
    'age': {
      'seconds': 's',
      'minutes': 'm',
      'hours': 'h',
      'days': 'd'
    }
  },
  'numberFormat': {
    'long': '#,###',
    'short': '###',
    'currency': '#,###.00',
    'percent': '#.00%'
  },
  'temperature': {
    'scale': 'celsius',
    'symbol': '&deg; C'
  },
  'sponsoredContentProviders': [ 'taboola', 'outbrain' ],
  'taboola': _merge({}, taboolaDefaults, taboola),
  'outbrain': {
    'enabled': true,
    'template': 'ESPNAfrica',
    'desktop': {
      'compliantId': 'AR_49',
      'nonCompliantId': 'AR_4'
    },
    'mobile': {
      'compliantId': 'AR_49',
      'nonCompliantId': 'MB_6'
    },
    'video': {
      'desktop': {
        'compliantId': 'AR_16'
      },
      'mobile': {
        'compliantId': 'MB_6'
      }
    },
    'recap': {
      'desktop': {
        'compliantId': 'AR_30',
        'nonCompliantId': 'AR_30'
      },
      'mobile': {
        'compliantId': 'MB_9',
        'nonCompliantId': 'MB_9'
      }
    },
    'report': {
      'desktop': {
        'compliantId': 'AR_30',
        'nonCompliantId': 'AR_30'
      },
      'mobile': {
        'compliantId': 'MB_9',
        'nonCompliantId': 'MB_9'
      }
    },
    'table': {
      'desktop': {
        'compliantId': 'AR_43'
      },
      'mobile': {
        'compliantId': 'MB_43'
      }
    },
    'game': {
      'desktop': {
        'compliantId': 'AR_48'
      },
      'mobile': {
        'compliantId': 'AR_48'
      }
    },
    'team': {
      'desktop': {
        'compliantId': 'SB_1'
      },
      'mobile': {
        'compliantId': 'SB_1'
      }
    }
  },
  'omniture': {
    'enabled': true
  },
  'chartBeat': {
    'enabled': true
  },
  'ads': {
    'disabled': false,
    'partnerAd': false,
    'dev-config': 18968331,
    'qa-config': 18968331,
    'prod-config': 18968331
  },
  'partnerModules': {
    'global': true,
    'nba': true,
    'womenbb': true,
    'golf': true,
    'endurance': true,
    'horse': true,
    'nascar': true
  },
  'sportBranding': [
    {
      'sport': 'cricket',
      'image': 'logo-uk-cricinfo',
      'url': null
    },
    {
      'sport': 'soccer',
      'image': 'logo-uk-fc',
      'url': null
    },
    {
      'sport': 'rugby',
      'image': 'logo-uk-scrum',
      'url': null
    },
    {
      'sport': 'ncaaw',
      'image': 'ESPNcom-powerby-espnw',
      'url': 'http://www.espnw.com'
    },
    {
      'sport': 'ncw',
      'image': 'ESPNcom-powerby-espnw',
      'url': 'http://www.espnw.com'
    },
    {
      'sport': 'wnba',
      'image': 'ESPNcom-powerby-espnw',
      'url': 'http://www.espnw.com'
    },
    {
      'sport': 'womenbb',
      'image': 'ESPNcom-powerby-espnw',
      'url': 'http://www.espnw.com'
    }
  ],
  'siteLogo': {
    'class': 'africa',
    'featurePhone': {
      'name': 'kwese-espn-logo',
      'width': 100,
      'height': 20
    }
  },
  'meta': {
    'titleBranding': ' - ESPN',
    'description': 'Visit ESPN to get up-to-the-minute sports news coverage, scores, highlights and commentary for NFL, MLB, NBA, College Football, NCAA Basketball and more.',
    'defaultMetaImage': 'espn_red.png',
    'social': {
      'twitter': {
        'twitterId': '',
        'card': 'summary',
        'app_id_iphone': '317469184',
        'site': 'espn',
        'app_name_googleplay': 'ESPN',
        'app_id_googleplay': 'com.espn.score_center',
        'app_name_iphone': 'ESPN',
        'language': 'en'
      },
      'facebook': {
        'id': '116656161708917',
        'og_site_name': 'ESPN.com',
        'locale': 'en_US'
      }
    }
  },
  'appDetails': {
    'ios': {
      'id': '317469184',
      'name': 'ESPN',
      'deepLinkUrl': 'ios-app://317469184/sportscenter',
      'deepLinkUrlScheme': 'sportscenter'
    },
    'android': {
      'id': 'com.espn.score_center',
      'name': 'ESPN',
      'deepLinkUrl': 'android-app://com.espn.score_center/sportscenter',
      'deepLinkUrlScheme': 'sportscenter'
    }
  },  
  'shop': {
    'enabled': false
  },
  'sportReplacements': {},
  'uriRewrites': {
    'urls': {
      'toEdition': {},
      'toEnglish': {}
    },
    'roots': {
      '/oly/summer/gymnastics/': '/oly/summer/gymnastics/',
      '/oly/summer/cycling/': '/oly/summer/cycling/',
      '/college-football/': '/ncf/',
      '/football/club': '/soccer/team',
      '/football/': '/soccer/',
      '/racing/nascar/': '/nascar/',
      '/racing/': '/rpm/',
      '/mens-college-basketball/': '/ncb/',
      '/womens-college-basketball/': '/ncw/',
      '/womens-basketball/': '/womenbb/',
      '/olympics/': '/oly/',
      '/cycling/': '/cycling/',
      '/figure-skating/': '/oly/',
      '/college-sports/': '/ncaa/',
      '/gymnastics/': '/oly/',
      '/skiing/': '/oly/',
      '/horse-racing/': '/horse/',
      '/sports/womenbb/': '/womenbb/',
      '/sports/horse/': '/horse/'
    },
    'pathSegments': {},
    'paramKeys': {},
    'paramValues': {}
  },
  'betting': {
    'enabled': true,
    'game': {
      'enabled': true
    }
  },
  'ticketProvider': 'stubHub',
  'showFavorites': true,
  'showMobileScoresLink': true,
  'favoriteSportsManagement': true,
  'showInsider': false,
  'showWatch' : true,
  'showCategory': true,
  'hideCategoryLinks': [
    600,
    1700
  ],
  'categorySettings': {
    'leagues': true,
    'athletes': true,
    'teams': true,
    'tags': true
  },
  'showFCContent': true,
  'showCricInfoContent': true,
  'cookieConsent': true,
  'scDeepLinking': true,
  'allowShortUrl': true,
  'allowPrintUrl': true,
  'allowUserAccountManagement': true,
  'nowFeed': true,
  'hasTickets': true,
  'searchUrl': 'http://search.espn.com/',
  'hasSearch': false,
  'gameSettings': {
    'topEventsId': 18748358,
    'promotedSoccerLeaguesCeId': 18748551,
    'showBroadcast': true
  },
  'fallback': {

    // curated indices: soccer, nba, rugby, cricket
    // automated indices: athletics, esports, cycling

    // fallback

    // UK
    'f1': 'espnuk-en-f1-index',
    'tennis': 'espnuk-en-tennis-index',
    'golf': 'espnuk-en-golf-index',
    'darts': 'espnuk-en-darts-index',
    'snooker': 'espnuk-en-snooker-index',

    // US
    'mma': 'espn-en-mma-index',
    'boxing': 'espn-en-boxing-index',
    'nfl': 'espn-en-nfl-index',
    'mlb': 'espn-en-mlb-index',
    'nhl': 'espn-en-nhl-index',
    'womenbb': 'espn-en-womenbb-index',
    'wwe': 'espn-en-wwe-index',
    'nascar': 'espn-en-nascar-index',
    'ncf': 'espn-en-ncf-index',
    'ncb': 'espn-en-ncb-index',
    'ncaa': 'espn-en-ncaa-index',
    'oly': 'espn-en-oly-index',
    'endurance': 'espn-en-endurance-index',
    'specialolympics': 'espn-en-specialolympics-index',

    // AU
    'motogp': 'espnau-en-motogp-index',
    'afl': 'espnau-en-afl-index',
    'netball': 'espnau-en-netball-index',
    'indy-car': 'espnau-en-indy-car-index'
  },
  'editionAlert': {
    'enabled': true,
    'text': 'You have come to the all new KweseESPN.com, for other ESPN editions, click above.'
  },
  'feeds': {
    'googlenews': {
      'allowedContentTypes': [
        'Story',
        'HeadlineNews'
      ]
    }
  },
  'tier2NavIds': {
    'boston': 12375278,
    'chicago': 12505826,
    'cleveland': 13977091,
    'dallas': 12505828,
    'los-angeles': 12505831,
    'milwaukee': 13977360,
    'new-york': 12505854,
    'fantasy/basketball': 12405600,
    'fantasy/football': 12405632,
    'fantasy/baseball': 12405631,
    'fantasy/hockey': 12405634,
    'fantasy': 13609307,
    'ncfrecruiting': 11588758,
    'ncbrecruiting': 11588880,
    'esports': 13663224,
    'onenacion': 13309315,
    'jayski' : 16584380,
    'ncf/weekday-walkthrough': 17165710,
    'wwe' : 17101058,
    'sportsnation': 12544987,
    'nba/stephen-curry': 14950765,
    'league': {
      'soccer': 13794648,
      'ncf': 13886385,
      'college-football': 13886385,
      'cricket': 15609108
    },
    'watch': 15726903,
    'espn/caponecup': 17140605,
    'analytics': 17587818,
    'espnenabled': 17538365,
    'insider': 17779675,
    'live': 17843176
  },
  'tier3NavIds': {
    'clubhouse': {
      'nba': 12293424,
      'mlb': 12343023,
      'mens-college-basketball': 13884705,
      'womens-college-basketball': 13930164,
      'soccer': 12294454,
      'nfl': 12509708,
      'college-football': 13345157,
      'cricket': 15368856,
      'rugby': 17326168
    },
    'doubletruck': 14830831
  },
  'latestVideoCollectionId': 18749053,
  'videoAutoStart': {
    'index': false,
    'scoreboard': false
  },
  'useMongo': true,
  'activeSite': false,
  'countries': [
    {
      'name': 'South Africa',
      'country-code': 'za',
      'showHreflang': true
    }
  ]
}



// WEBPACK FOOTER //
// ../app/lib/utils/editions/config/southafrica.js